

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>







<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>


<br><br>
<br><br>



<div class="row" data-aos="zoom-in" data-aos-delay="300"   >
  <div class="col">
      <div style="
      margin: 0 auto;
      float: none;
      margin-bottom: 10px;
      background-color: #eff8ff;" class="card w-65">
      <div class="card-body">
          <h2 style="text-align: center;font-size: 550;color: #6ab187;">What do you require for Aadhaar Card<br> Verification?</h2>
      </div>
      </div>
  </div>
  </div>
  

     
<div class="row p-4" data-aos="fade-up" data-aos-delay="300"  >

  <div   class="col-md-4">
      <br>
      <img style="width: 60px;height: 65px;" src="assets/fakeaadhar.png">
     <br><br><br>
      <h5 >Forged Aadhaar Identity Document</h5>
      <p style="align-items: center;">During the onboarding process, companies utilise Aadhaar to verify the identification of their consumers. The most common source of frauds are forgeries.</p>
  </div>

  <div class="col-md-4">
        <br>
        <img style="width: 70px;height: 80px;" src="assets/incompleteaadhar.png">
       <br><br>
        <h5>Incomplete/Wrong Aadhaar details</h5>
        <p style="align-items: center;">False or incomplete Aadhaar details could cause problems for someone who wants to use specific services from banks or telecom companies.</p>
    </div>
   
    <div class="col-md-4">
   
      <br>
      <img style="width: 60px;height: 60px;" src="assets/compliance.png">
     <br><br><br>
      <h5 >Risk, Privacy and Compliance</h5>
      <p style="align-items: center;">Aadhaar contains sensitive personal data including biometrics. Appropriate security and compliance measures must be in place<p>
  </div>

</div>


<!-- api -->
<br><br>

  <h1 data-aos="zoom-in" data-aos-delay="300"  style="text-align: center;color: #6ab187;">Types of Aadhaar Verification API's​​</h1><br>
  <h6 data-aos="zoom-in" data-aos-delay="300" style="text-align: center;color: gray;">Choose from different types of instant Aadhaar API’s as per your output requirement</h6>
  <br>
  <!-- verification api's -->
    <div style="background-color: azure;" class="row p-2">
      <div class="col-md-3 mt-2">
          <div class="card" data-aos="fade-up" data-aos-delay="300" >
              <div class="card-body">
                  <img style="width: 25%;height:25%" src="assets/basicaadhar.png">
                  <br><br>
                <h5 class="card-title">Basic Aadhaar Verification</h5>
                <p class="card-text">The quickest way to verify basic details like Age-group, State, Gender, Registered Mobile Number and Address</p>
                  
              </div>            
            </div>
      </div>
  
      <div class="col-md-3 mt-2">
  
          <div class="card" data-aos="fade-up" data-aos-delay="310"   >
              <div class="card-body">
                  <img style="width: 25%;height:25%" src="assets/otp.png"><br>
                  <br>
                <h5 class="card-title">OTP-based Aadhaar Paperless eKYC</h5>
                <p class="card-text">OTP-based verification to fetch complete details for POI and POA verification</p>
              </div>            
            </div>
      </div>
  
      <div class="col-md-3 mt-2">
          <div class="card" data-aos="fade-up" data-aos-delay="320" >
              <div class="card-body">
                  <img style="width: 25%;height:25%" src="assets/paperless.png">
                  <br><br>
                <h5 class="card-title">Aadhaar Paperless Offline eKYC</h5>
                <p class="card-text">Consent-based service to upload Aadhaar number XML file and fetch e-Aadhaar details</p>
              </div>            
            </div>
      </div>
  
      <div class="col-md-3 mt-2">
  
          <div class="card" data-aos="fade-up" data-aos-delay="330">
              <div class="card-body">
                  <img style="width: 35%;height:34%" src="assets/ocr.png">
                    <h4 class="card-title">Aadhaar Verification via Digilocker</h4>
                <p class="card-text">Fetch Aadhaar Details from Digilocker with an OTP an consent based verification</p>
              </div>            
            </div>
      </div>
      
      <div class="col-md-3 mt-2">
        <div class="card " style="height: 240px;" data-aos="fade-up" data-aos-delay="340" >
            <div class="card-body">
                <img style="width: 30%;height:25%" src="assets/digilocker.png">
                <br>
              <h5 class="card-title">Aadhaar Paperless Verification API</h5>
              <p class="card-text">Digital Identification using consent based Aadhaar paperless verification API</p>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2">

        <div class="card" style="height: 240px;" data-aos="fade-up" data-aos-delay="350" >
            <div class="card-body">
                <img style="width: 25%;height:25%" src="assets/ocraadhar.png"><br>
                <br>
              <h5 class="card-title">Aadhaar Details via OCR</h5>
              <p class="card-text">Read Aadhaar Document /image via Optical Character Recognition(OCR) Technology</p>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2">

        <div class="card" style="height: 240px;" data-aos="fade-up" data-aos-delay="360" >
            <div class="card-body">
                <img style="width: 25%;height:25%" src="assets/aadharvalidate.png">
                <br><br>
              <h5 class="card-title">Aadhaar Number Validation</h5>
              <p class="card-text">Real-time validation of an Aadhaar number or Aadhaar Document</p>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2">

        <div class="card"  style="height: 240px;" data-aos="fade-up" data-aos-delay="370" >
            <div class="card-body">
                <img style="width: 25%;height:29%;border-radius: 15px;" src="assets/masking.png">
                <br><br>
                  <h5 class="card-title">Aadhaar Number Masking</h5>
              <p class="card-text">Stay Compliant with Authbridge’s Aadhaar Masking API</p>
            </div>            
          </div>
    </div>
  
    </div>
   
    
   
    <br><br>
  

<div class="row p-2" data-aos="zoom-in" data-aos-delay="300"  >
  <div class="col  text-center">
      <div  class="card ">
      <div class="card-body">
          <h2 style="text-align: center;font-size: 550;color: #6ab187;">FaCheck's Aadhaar Verification API's Advantages</h2>
      </div>
      </div>
  </div>
  </div>
  <br><br><br>

   
<div  class="row p-2"  >

  <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300" class="col-md-4">
      <br>
      <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/easy.png">
     <br><br><br>
      <h5>Easy To Use</h5>
      <p style="align-items: center;">FaCheck's Aadhaar authentication API is optimized for seamless user experience. 
      </p>
  </div>

  <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300" class="col-md-4">
        <br>
        <img style="width: 70px;height: 80px;" src="assets/complaint.png">
       <br><br>
        <h5 >Stay Compliant</h5>
        <p style="align-items: center;">Verifies all the information provided with the Aadhaar department ensuring they are legit and accurate.</p>
    </div>
   
    <div  style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300" class="col-md-4">
   
      <br>
      <img style="width: 60px;height: 60px;" src="assets/identity.png">
     <br><br><br>
      <h5 >Prevents Identity Frauds</h5>
      <p style="align-items: center;">Our API detects fraudsters using fake Aadhaar cards or fake credentials.<p>
  </div>
  

  <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300" class="col-md-4">
    <br>
    <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/realtime.png">
   <br><br><br>
    <h5>Real-Time Verification</h5>
    <p style="align-items: center;">Data is retrieved and verified within a few seconds –
      saving you time and costs.
    </p>
</div>

<div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300" class="col-md-4">
      <br>
      <img style="width: 70px;height: 80px;" src="assets/play&plug.png">
     <br><br>
      <h5 >Plug and Play API’s</h5>
      <p style="align-items: center;">Web portal, APIs, and Mobile SDK with no third-party
        assistance</p>
  </div>
 
  <div  style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300" class="col-md-4">
 
    <br>
    <img style="width: 60px;height: 60px;margin-top: 20px;" src="assets/handshake.jpg">
   <br><br><br>
    <h5 >Instant Onboarding</h5>
    <p style="align-items: center;">Onboard customers, third-parties, employees in 2-5 minutes<p>
</div>


</div>





  <!-- faq -->
  <div data-aos="zoom-in" data-aos-delay="300" class="faq-title text-center pb-3 mt-4">
    <h2>FAQ</h2>
</div>


<div class="row" data-aos="fade-up" data-aos-delay="300">

    
    <div id="slide"  class="col-md-6 text-center">
      <h1 style="color: #6ab187;">FACheck's FAQ</h1>
     </div>
     <div class="col-md-6">
      <div style="width: 90%;" class="faq-content">
          <div class="faq-question">
            <input id="q1" type="checkbox" class="panel">
           
            <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
            <label for="q1" class="panel-title"> &nbsp;&nbsp; What is the need for Aadhaar Card Verification? </label>
            <div class="panel-content">It is needed to verify the identity of customers, third-parties, employees to prevent any risks of frauds before any onboarding or recruitment process. It is the crucial part of verification and onboarding to confirm the accuracy of person information and identification.</div>
          </div>
          
          <div class="faq-question">
            <input id="q2" type="checkbox" class="panel">
            <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
            <label for="q2" class="panel-title">&nbsp;&nbsp; Why is it important to verify identities? </label>
            <div class="panel-content">It is important to verify identities through Aadhaar verification to protect your business from identity theft and money laundering and stay compliant with the laws and guidelines. </div>
          </div>
          
          <div class="faq-question">
            <input id="q3" type="checkbox" class="panel">
            <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
            <label for="q3" class="panel-title">&nbsp;&nbsp; What is Aadhaar based e-KYC solution?  </label>
            <div class="panel-content">Paperless e-KYC (Know Your Customer) is presented by UIDAI to enforce inclusion, privacy and security. It will allow Aadhaar holders to voluntarily utilize their cards to confirm their identification in a paperless and digital manner. </div>
          </div>
      
          <div class="faq-question">
              <input id="q4" type="checkbox" class="panel">
              
             <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q4" class="panel-title">&nbsp;&nbsp; How is Aadhaar based e-KYC better than Offline KYC? </label>
              <div class="panel-content">Aadhaar based e-KYC significantly lowers the cost of paper-based verification and KYC and the resources required to maintain it, like people, inventory, storage, etc resulting in massive cost-cutting. Privacy is also addressed under E-KYC as the Aadhaar number of the customer is not disclosed, only a reference ID is shared. </div>
            </div>
            
            <div class="faq-question">
              <input id="q5" type="checkbox" class="panel">
              
             <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q5" class="panel-title">&nbsp;&nbsp;Why should I get Facheck Aadhaar Verification?  </label>
              <div class="panel-content">Facheck’s Aadhaar Verification Solution will provide authentication of customers/users by verifying Aadhar Card within a few seconds. </div>
            </div>

            <div class="faq-question">
              <input id="q6" type="checkbox" class="panel">
              
             <img style="width: 30px;height: 30px;margin-top: 13px;" class="plus" src="assets/handlogo.png">
              <label for="q6" class="panel-title">&nbsp;&nbsp;What are the details that I will be able to see on Verifying Aadhaar? 
              </label>
              <div class="panel-content">Once an Aadhaar number is entered, the system will return whether the Aadhaar is valid or not along with the following details: Age, Gender, State, Mobile number (last four digits) </div>
            </div>
        </div>
  </div>
</div>

  



